import Image from 'next/image'

import { cn } from '../../utils'

import { AccentHighlight } from './AccentHighlight'

export const HighlightGradientBox = ({
  children,
  className,
  cornerImage,
  hoverEffect,
}: {
  cornerImage?: boolean
  children: React.ReactNode
  className?: string
  hoverEffect?: boolean
}) => {
  return (
    <article className={cn('rounded-[12px] bg-gradient-to-r from-[#91B3F0]/40 to-[#1f2124] p-[1px] w-full', className)}>
      <div className="h-full w-full rounded-[10px] bg-background-accent p-2 relative group">
        <div
          className={cn(
            'h-full w-full gradient-box-gradient rounded-[10px] relative overflow-hidden transition-all duration-300 ease-in-out',
            cornerImage && 'min-h-[350px] sm:min-h-[300px]',
            hoverEffect && 'gradient-box-gradient-hover',
          )}
        >
          <Image
            src="/shared/grid3.png"
            alt="grid"
            fill
            className="absolute top-0 left-0 opacity-15"
            priority={false}
            style={{ transform: 'scale(2.3)' }}
          />
          <div className="relative z-10 h-full w-full">{children}</div>
          <AccentHighlight className="bottom-[0px] h-[1px] w-[70%] left-[50%] translate-x-[-50%]" />
        </div>
        <AccentHighlight className="bottom-[6px] h-[1px] w-[68%] left-[50%] translate-x-[-50%]" />
      </div>
    </article>
  )
}
